<template>
    <div class="well-time-view" :title="$translate('current_frame_time')">
        <i v-if="!minimal" class="fa fa-clock-o mr-2" />
        <span v-if="showNa">{{ $translate('na') }}</span>
        <span v-else>{{ currentWellTime_h }}{{ $translate('h_hour') }}</span>
    </div>
</template>

<script>
export default {
    name: 'WellTimeView',
    props: {
        currentWellTime_h: {
            type: Number,
            required: true
        },
        minimal: {
            type: Boolean,
            default: false
        },
        showNa: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style lang="scss" scoped>
.well-time-view {
    display: flex;
    align-items: center;
    color: $light-3;
    border-radius: $border-radius;
    z-index: 1;

    .fa-clock-o {
        font-size: 15pt;
    }
}
</style>
